export default {
  showRegistrationModalOnQr: false,
  general: {
    showLayoutSwitchToggle: true,
    appResetTimeoutMinutes: 15,
  },

  filter: {
    enabled: false,
  },
};
